"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Supplier = void 0;
const Organization_1 = require("./Organization");
const typeName = 'Supplier';
class Supplier extends Organization_1.Organization {
    constructor(ob) {
        super({ ...ob, type: ob.type || typeName });
    }
}
exports.Supplier = Supplier;
